define('BookingEngine/app-Reviewpay/settings',[],function () {
    return {
        container: '#reviewpay',
        submiturl: window.location.protocol + '//' + window.location.host + '/reviewpaysave/'
    };
});
